export default __webpack_public_path__ + "static/media/Iphone-14-PRO.770e44e1.svg";